import React from 'react'

function EmailField(field) {
  return (
    <input
      type="email"
      value={field.value}
      name={field.name}
      onChange={e => {
        field.onChange(e)
      }}
      onBlur={e => field.onBlur(e)}
      className="form__input"
      id="email"
      required
    />
  )
}

export default EmailField
